<template>
    <div>
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <app-breadcrumb :page-title="$t('packers_list')" :directory="$t('list')" :icon="'grid'" />
                </div>
                <div class="col-sm-12 col-md-6 breadcrumb-side-button">
                    <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
                        <button 
                            @click=" addPacker = true, list = false"
                            type="button" class="btn btn-primary btn-with-shadow">
                            {{ $t('add_packer') }}
                        </button>
                    </div> 
                </div>
            </div>
            <app-table :id="tableId" :options="options" @action="getListAction" :selected-url="selectedUrl" />
        </div>
        <AddPacker 
            v-if="addPacker"
            @close="addPacker = false"
            @save="handleSavePacker" />

        <EditPacker
            v-if="editPacker"
            :packer_id="this.rowData.id"
            @close="editPacker = false"
            @save="handleUpdatePacker" />    
    
        <app-delete-modal 
            v-if="deleteConfirmationModalActive" 
            :preloader="deleteLoader" 
            modal-id="demo-delete"
            @confirmed="confirmed" 
            @cancelled="cancelled" />

    </div>
</template>

<script>
import configTable from "./mixins/configTable";
import * as actions from "../../../Config/ApiUrl.js";
import { FormMixin } from '../../../../core/mixins/form/FormMixin.js';
import CoreLibrary from "../../../../core/helpers/CoreLibrary.js";
import AddPacker from "./AddPacker.vue";
import EditPacker from "./EditPacker.vue";
import { tableLocation } from './mixins/tableLPackers.js';
import { savePacker, updatePacker, deletePacker } from "./api/api";

export default {
    extends: CoreLibrary,
    mixins: [tableLocation, FormMixin],
    components :{
        AddPacker, EditPacker
    },  
    data() {
        return {
            tableId: 'advance-table',
            options: configTable,
            addPacker : false,
            editPacker : false,
            deleteConfirmationModalActive: false,
            deleteLoader: false,
            rowData: {},
        }
    },
    created() {
        this.options.columns = this.tableColumns; // Asignar las columnas de la tabla
    },
    methods : {
        getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
            if (actionObj.title === 'Delete') {
                this.openDeleteModal();
            }
            if (actionObj.title === 'Edit') {
                this.openEditModal();
            }
        },  

        async handleSavePacker(data){
            const res = await savePacker(data);
            if (res.created) {
                this.$toastr.s(res.message);
                this.addPacker = false;
                return;
            }
            this.$toastr.e(res.message);
        },

        openDeleteModal() {
            this.deleteConfirmationModalActive = true;
        },

        cancelled() {
            this.deleteConfirmationModalActive = false;
            location.reload();
        },

        async confirmed() {
            const id = this.rowData.id;
            const res = await deletePacker(id);
            if (res.deleted) {
                $("#demo-delete").modal('hide');
                this.$toastr.s(res.message);
                this.cancelled();
                return;
            }
            this.$toastr.e(res.message);
        },

        openEditModal() {
            this.editPacker = true;
        },

        async handleUpdatePacker(data){
            const res = await updatePacker(data);
            if (res.updated) {
                this.$toastr.s(res.message);
                this.editCity = false;
                location.reload();
                return;
            }
            this.$toastr.e(res.message);
        }
    },
}
    
</script>

